export default [
    {
        path: '/sections',
        name: 'sections',
        component: () =>
            import ('@/views/pages/sections/sections-list/SectionsList.vue'),
        meta: {
            pageTitle: 'Sections',
            breacrumb: [{
                text: 'Section',
                active: true,
                to: '/sections',
            }],
            resource: 'section',
            action: 'read',
        },
    },
    {
        path: '/sections/view/:id',
        name: 'sections-view',
        component: () =>
            import ('@/views/pages/sections/sections-view/SectionsView.vue'),
        meta: {
            pageTitle: 'View Section',
            breadcrumb: [
            {
                text: 'Sections',
                to: '/sections',
            },{
                text: 'View',
                active: true,
            } ],
            resource: 'section',
            action: 'read',
        },
    },
    {
        path: '/sections/edit/:id',
        name: 'sections-edit',
        component: () =>
            import ('@/views/pages/sections/sections-edit/SectionsEdit.vue'),
        meta: {
            pageTitle: 'Edit Section',
            breadcrumb: [
            {
                text: 'Sections',
                to:'/sections',
            },
            {
                text: 'Edit',
                active: true,
            } ],
            resource: 'section',
            action: 'read',
        },
    },
    {
        path: '/sections/add',
        name: 'sections-add',
        component: () =>
            import ('@/views/pages/sections/sections-add/SectionsAdd.vue'),
        meta: {
            pageTitle: 'Add Section',
            breadcrumb: [
            {
                text: 'Sections',
                to:'/sections',
            },
            {
                text: 'Add',
                active: true,
            } ],
            resource: 'section',
            action: 'read',
        },
    },
]